import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { waLink } from '../data/whatsapp';

const { FiArrowUpRight, FiArrowDown, FiPlay } = FiIcons;

function Hero() {
  return (
    <section className="hero">
      <div className="hero-image" role="img" aria-label="Athlete training in a premium studio" />
      <div className="hero-shade" />
      <div className="hero-grid" aria-hidden="true">
        {Array.from({ length: 6 }).map((_, i) => <span key={i} />)}
      </div>
      <motion.div
        className="hero-content"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
      >
        <span className="hero-kicker"><i /> EST. 2018 — YOUR CITY, YOUR CLUB</span>
        <h1>Stronger<br />looks good<br /><em>on you.</em></h1>
        <p>Training for real life, built around you. Find your pace. Find your people. A premium fitness experience designed for every body.</p>
        <div className="hero-actions">
          <a className="button button-lime" href={waLink('Hi! I want to book a free trial session.')} target="_blank" rel="noreferrer">
            Book a free trial <SafeIcon icon={FiArrowUpRight} />
          </a>
          <a className="play-link" href="#showcase">
            <span><SafeIcon icon={FiPlay} /></span> Watch the tour
          </a>
        </div>
      </motion.div>
      <div className="hero-meta">
        <div className="hero-meta-item"><strong>12k+</strong><span>Members trained</span></div>
        <div className="hero-meta-item"><strong>45+</strong><span>Weekly classes</span></div>
        <div className="hero-meta-item"><strong>4.9</strong><span>Avg. rating</span></div>
      </div>
      <a className="hero-scroll" href="#stats"><SafeIcon icon={FiArrowDown} /> SCROLL</a>
    </section>
  );
}
export default Hero;
